module.exports = __webpack_public_path__ + "img/28.558ce863.png";